import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onLivePersonaEditorInternal = action('onLivePersonaEditorInternal', event => ({
    event,
    owaType: 'livePersonaEditorInternal',
})) as OwaNovaActionUnion<'livePersonaEditorInternal'>;
